import { render, staticRenderFns } from "./form-meio-ambiente.vue?vue&type=template&id=276f1b6e&"
import script from "./form-meio-ambiente.vue?vue&type=script&lang=js&"
export * from "./form-meio-ambiente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports